import { useEffect, useState } from 'react';
import { authHeaders } from '../lib/api.ts';

/**
 * How a counter PC gets the app.
 *
 * Enrolment issues a code, but nothing in here ever said where to
 * get the thing the code goes into. That gap is the difference
 * between a rollout and a support call per site.
 */
type Build = {
  version: string;
  filename: string;
  url: string;
  notes?: string;
};

export const InstallCard = () => {
  const [b, setB] = useState<Build | null>(null);
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    fetch('/admin/download', {
      credentials: 'same-origin', headers: authHeaders(),
    })
      .then((r) => (r.ok ? r.json() : Promise.reject()))
      .then(setB)
      .catch(() => undefined);
  }, []);

  if (!b) return null;

  const share = async () => {
    try {
      await navigator.clipboard.writeText(b.url);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch {
      // Clipboard can be refused; the link is visible and selectable.
    }
  };

  return (
    <section className="composer installCard">
      <p className="mono">Counter app for Windows</p>
      <p className="hint">
        Install this on each counter PC, then enrol it with a code
        from below. The link is public, so it can be sent to whoever
        is setting the machine up: a code is what grants access, not
        the installer.
      </p>

      <div className="noticeRow">
        <a className="btnLink primary" href={b.url} download>
          Download {b.filename}
        </a>
        <button onClick={share}>
          {copied ? 'Link copied' : 'Copy link to share'}
        </button>
        <span className="mono">version {b.version}</span>
      </div>
    </section>
  );
};
